import { FailNachaPaymentsRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

export const validateFailNachaPayments = makeValidator({
  FieldParser: FailNachaPaymentsRow,
});
